import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Image } from '@flxlease/flexinui';
// Add ImageProps import
import AWS from 'aws-sdk';

import { Property } from '../../../Graphql/Generated/graphql';
import { BlogPost } from '../../BlogEntries/BlogPostData';
import '../DisplayListings/DisplayListings.css';

const S3_BUCKET = process.env.REACT_APP_S3_NAME;
const REGION = process.env.REACT_APP_S3_REGION;

AWS.config.update({
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

interface IPropsImage {
  width: number | string;
  height: number | string;
  filename: string;
  src?: string;
  className?: string;
  loading?: 'eager' | 'lazy' | undefined;
  place?: Property;
  blog?: BlogPost;
}

const ImageLoader = (props: IPropsImage) => {
  const navigate = useNavigate();
  const [image, setImage] = useState('');

  const fetchImages = async (fileName: any) => {
    try {
      const params = {
        Bucket: S3_BUCKET ?? '',
        Key: fileName,
      };

      const data: any = await myBucket.getObject(params).promise();

      const blob = new Blob([data.Body ? data.Body.buffer : null]);

      const url = URL.createObjectURL(blob);

      setImage(url);
    } catch (error) {
      setImage('bedroom.jpeg');
    }
  };

  const toPage = (e: React.MouseEvent<HTMLDivElement>) => {
    const tag = e.target as HTMLTextAreaElement;
    if (props.place && tag.className?.includes('propertyGradient')) {
      const urlSafeTitle = encodeURIComponent(props.place.title || '');
      navigate(`/property/${urlSafeTitle}`, { state: props.place });
    } else if (props.blog) {
      navigate(`/blog-post/${props.blog.url}`, { state: props.blog });
    }
  };

  useEffect(() => {
    if (!props?.filename?.startsWith('https')) {
      fetchImages(props.filename);
    }
  }, [props?.filename]);

  return (
    <Image
      skeleton={true}
      src={props?.filename?.startsWith('https') ? props.filename : image}
      alt={props.place?.title ?? `Listings image`}
      // @ts-ignore
      className={props.className} // Add className prop
      // @ts-ignore
      onClick={(e: any) => toPage(e)}
      loading={props.loading ?? 'lazy'}
      {...props}
    />
  );
};

export default ImageLoader;
